<template>
  <div class="phone-menu">
    <div class="inner">
      <!-- <fa v-if="!hideMenu" icon="bars" class="menu-item" @click="$emit('toggleNav')" /> -->
      <router-link class="menu-item" to="/dashboard/" active-class="active" exact>
        <fa icon="home" />
      </router-link>
      <router-link class="menu-item" to="/dashboard/organizations" active-class="active">
        <fa icon="building" />
      </router-link>
      <router-link class="menu-item circle" to="/dashboard/stations" active-class="active">
        <fa icon="map-marker-alt" />
      </router-link>
      <router-link class="menu-item" to="/dashboard/transactions" active-class="active">
        <fa icon="credit-card" />
      </router-link>
      <router-link class="menu-item" to="/dashboard/profile" active-class="active">
        <fa icon="cog" />
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PhoneMenu',
    props: {
      hideMenu: Boolean
    }
  }
</script>

<style lang="scss" scoped>
  .phone-menu {
    display: none;
    width: 100%;
    background-color: white; 
    // position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99999999;

    box-shadow: 0px 0px 5px 0px rgba($text-light, .1);
    border-top: 1px solid $border;

    @include breakpoint (xs) {
      display:block;
    }

    .inner {
      display: flex;
      height: 50px;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
    }
  }

  .menu-item {
    text-decoration: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: $text;
    padding: 15px;

    &.active {
      color: $main;
    }

    &:focus, &:active {
      color: $main;
      background-color: none;
      box-shadow: none;
    }

    &.circle {
      padding: 20px;
      height: 20px;
      width: 20px;
      border-radius: 100%;
      background-color: white; 
      box-shadow: 0px 0px 5px 0px rgba($text-light, .5);
    }

    i, svg {
      font-size: 22px;
    }

  }
</style>




// WEBPACK FOOTER //
// src/components/dashboard/PhoneMenu.vue